<div class="sticky-footer">
  @for (item of mainItems; track item) {
    <div class="sticky-footer-item">
      @if (item.link) {
        <a
          [routerLink]="item.link"
          [routerLinkActive]="'bc-simple-primary'"
          (click)="itemClicked(item)"
          appButton
          name="{{ item.text || item.key | lowercase | replace: ' ' : '-' | replace: '&' : '-' }}"
          location="sticky-footer"
          contextButton
          [hasIcon]="true"
          color="simple"
          [verticalIcon]="true"
          spacing="full"
        >
          <app-svg [src]="'/assets/icons/' + item.icon + '.svg'"></app-svg>
          <span>{{ item.text }}</span>
          @if (item.newDot) {
            <app-new-feature-dot [featureName]="item.newDot"></app-new-feature-dot>
          }
        </a>
      }
      @if (!item.link) {
        <button
          [class.bc-simple-primary]="item.key === selected"
          appButton
          name="{{ item.text || item.key | lowercase | replace: ' ' : '-' | replace: '&' : '-' }}"
          location="sticky-footer"
          contextButton
          [hasIcon]="true"
          color="simple"
          [verticalIcon]="true"
          spacing="full"
          (click)="itemClicked(item)"
        >
          <app-svg [src]="'/assets/icons/' + item.icon + '.svg'"></app-svg>
          <span>{{ item.text }}</span>
          @if (item.newDot) {
            <app-new-feature-dot [featureName]="item.newDot"></app-new-feature-dot>
          }
        </button>
      }
    </div>
  }
  @if (allItems.length) {
    <div class="sticky-footer-item">
      <app-context-menu [options]="{ width: '200px', noSpacing: true }" #menu>
        <button
          appButton
          name="more"
          location="sticky-footer"
          contextButton
          [hasIcon]="true"
          color="simple"
          [verticalIcon]="true"
          spacing="full"
        >
          <app-svg src="/assets/icons/dots-horizontal.svg"></app-svg>
          <span>More</span>
        </button>
        <div contextContent>
          <div class="button-menu">
            @for (item of allItems; track item) {
              <a [routerLink]="item.link">
                <app-button-menu-item
                  [name]="item.text || item.key | lowercase | replace: ' ' : '-' | replace: '&' : '-'"
                  location="sticky-footer"
                  (click)="menu.close()"
                  [fullWidth]="true"
                  [icon]="item.icon"
                >
                  {{ item.text }}
                </app-button-menu-item>
              </a>
            }
          </div>
        </div>
      </app-context-menu>
    </div>
  }
  <ng-content></ng-content>
</div>
